module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-timber-kimberly-0.9f89afa4.jpg";